"use client";

import { useContext, useState } from "react";
import { FlaskConical } from "lucide-react";

import { Button } from "@acme/ui/button";

import { AuthContext } from "~/features/auth/_providers/auth.provider.js";
import { TrpcTestingDialog } from "./trpc-testing-dialog.js";

export function TrpcTestingTrigger()
{
  const auth = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const isLoggedIn = auth?.isAuthenticated ?? false;

  if (!isLoggedIn) return null;

  return (
    <>
      <Button variant="outline" size="icon" onClick={() => setOpen(true)} title="tRPC Testing" className="shrink-0">
        <FlaskConical className="h-4 w-4" />
        <span className="sr-only">tRPC Testing</span>
      </Button>
      <TrpcTestingDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
